"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CampaignConnectionValues = exports.CampaignConnectionStatus = void 0;
var CampaignConnectionStatus;
exports.CampaignConnectionStatus = CampaignConnectionStatus;

(function (CampaignConnectionStatus) {
  CampaignConnectionStatus["Connected"] = "CAMPAIGN_CONNECTED";
  CampaignConnectionStatus["NotConnected"] = "CAMPAIGN_NOT_CONNECTED";
})(CampaignConnectionStatus || (exports.CampaignConnectionStatus = CampaignConnectionStatus = {}));

var CampaignConnectionValues;
exports.CampaignConnectionValues = CampaignConnectionValues;

(function (CampaignConnectionValues) {
  CampaignConnectionValues["Connected"] = "Connected to Salesforce";
  CampaignConnectionValues["NotConnected"] = "Not Connected to Salesforce";
  CampaignConnectionValues["SyncFailed"] = "Not Connected to Salesforce - Synchronization failed";
})(CampaignConnectionValues || (exports.CampaignConnectionValues = CampaignConnectionValues = {}));